import * as React from "react";
import { IconListSparkle } from "central-icons/IconListSparkle";
import { IconCodeAssistant } from "central-icons/IconCodeAssistant";
import * as TogglePrimitive from "@radix-ui/react-toggle";
import { cn } from "@/components/podkit/lib/cn";

// eslint-disable-next-line react-refresh/only-export-components
export enum Mode {
    Spec = "spec",
    Default = "default",
}

export const SpecModeToggle = ({ mode, onModeChange }: { mode: Mode; onModeChange: (mode: Mode) => void }) => {
    const isPressed = mode === Mode.Spec;

    const handlePressedChange = (pressed: boolean) => {
        onModeChange(pressed ? Mode.Spec : Mode.Default);
    };

    return (
        <Toggle
            aria-label="Toggle spec mode"
            pressed={isPressed}
            onPressedChange={handlePressedChange}
            className="border-0 text-content-muted"
        >
            {isPressed ? <span>Specification mode</span> : <span>Quick fix mode</span>}
            {isPressed ? <IconListSparkle size={16} /> : <IconCodeAssistant size={16} />}
        </Toggle>
    );
};

// Note(Mads): DO NOT EXPORT THIS AND USE IT ELSEWHERE!
// This was added as part of a prototype just for SpecModeToggle.
export const Toggle = React.forwardRef<
    React.ElementRef<typeof TogglePrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root>
>(({ className, ...props }, ref) => {
    return (
        <TogglePrimitive.Root
            ref={ref}
            data-slot="toggle"
            className={cn(
                "hover:bg-muted hover:text-muted-foreground data-[state=on]:bg-accent data-[state=on]:text-accent-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive shadow-xs hover:text-accent-foreground inline-flex h-8 min-w-8 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-border-base bg-transparent px-1.5 text-sm font-medium outline-none transition-[color,box-shadow] hover:bg-surface-hover focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 [&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0",
                className,
            )}
            {...props}
        />
    );
});

Toggle.displayName = TogglePrimitive.Root.displayName;
